import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { TextInput } from 'elements'
import { parseQueryString } from 'utils/helpers'

import { clientId } from '@/index'
import { Tooltip, Button } from 'antd';
import './index.scss';

class FilterBar extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    onSearchChange: PropTypes.func,
    setURLHref: PropTypes.func.isRequired
  };

  handleSearchEnter = (search) => {
    const { location, setURLHref } = this.props
    const params = {
      ...parseQueryString(location.search),
      search
    }
    setURLHref(params)
  };

  render() {
    const { location, onSearchChange } = this.props
    const params = parseQueryString(location.search)

    return (
      <div>
        <div className="right-side-options">
          <TextInput.Search
            defaultValue={params.search}
            placeholder="Search"
            onChange={onSearchChange}
            onSearch={this.handleSearchEnter}
            enterButton
          />
        </div>
        {
          ( clientId === 'gleneagles' || clientId === 'tramp' ) &&
          <div className="right-side-options">
          <Tooltip title={
            <React.Fragment>
              <table>
                <tbody>
                  <tr>
                    <td id="birthday-square"> </td>
                    <td>&nbsp;= Birthday</td>
                  </tr>
                  <tr>
                    <td id="new-member-square"> </td>
                    <td>&nbsp;= New Member</td>
                  </tr>
                  <tr>
                    <td id="expired-member-square"> </td>
                    <td>&nbsp;= Expired Member</td>
                  </tr>
                  <tr>
                    <td id="top-spender-square"> </td>
                    <td>&nbsp;= Top Spender</td>
                  </tr>
                </tbody>
              </table>
            </React.Fragment>
          } placement="bottom" arrow={true}>   
            <Button id="border-key">Border key</Button>
          </Tooltip>
        </div>
        }
      </div>
    )
  }
}

export default withRouter(FilterBar)



// WEBPACK FOOTER //
// ./src/pages/live-view/components/filter-bar/index.js